module.exports = __webpack_public_path__ + "img/parliament-7.1d6860bb.webp";